import { Link } from "react-router-dom";
import ImageComponent from "../utils/ImageComponent";

// Where the account app actually lives: the Pocket Ledger Web app on its own
// host, which is the only one of the two that has a real /login route. The
// login CTA is a plain <a> to this absolute URL rather than a router
// <Link to="/account">, so a click lands on the deployed account app even
// though this marketing page is served from a different host.
const ACCOUNT_LOGIN_URL = "https://plweb.eeighttech.com/login";

// The invoice generator, the one thing on this page a visitor can use without
// an account. It is a public route of the same web app /login belongs to, so
// the link is absolute for the same reason that one is: different host.
//
// It is linked from here because nothing else links to it — a shared invoice's
// QR and footer point at this page, and the generator is the other end of that
// trade: someone who will not install the app can still produce the document.
const GENERATOR_URL = "https://plweb.eeighttech.com/tools/invoice-generator";

export default function HomeArea() {
  return (
    <>
      <div className="home_area">
        <div className="container text-center">
          <h1>Pocket Ledger</h1>
          <h2>Your All-in-One Financial Companion</h2>
          <p className="mt_15 mx-auto">
            Whether you're managing personal 
            budgets or running a business, our intuitive app simplifies expense tracking, 
            bookkeeping, and receipt management. Snap photos of receipts, set smart reminders, 
            and generate insightful reports to stay on top of your financial game. 
            Perfect for personal finaces,freelancers, small business owners, or anyone looking to streamline their money matters. 
            
          </p>
          
          
          <a href={ACCOUNT_LOGIN_URL} className="button mt_30 mb_20">
            Login to your Account
          </a>

          <p className="hero-tools">
            <a href={GENERATOR_URL} className="hero-tools-link">
              Make a free invoice — no account needed
            </a>
          </p>

          <div className="mobile_wrap mx-auto">
            <div className="row align-items-center">
             
              <div >
                <ImageComponent src="/img/pllandinghome.png" className="w-100" />
              </div>
             
            </div>

            <div className="row align-items-center">
              <div className="col">
                {/* No `/us/` segment: with a country in the path Apple keeps
                    the visitor on that storefront, so an Indian visitor saw
                    USD pricing and the US rating count. Without it the App
                    Store picks the visitor's own storefront, which is also
                    the form the in-app links use. */}
                <Link to="https://apps.apple.com/app/id6463052653" target="_blank">
                  <ImageComponent src="/img/appstore.png" className="w-100" />
                </Link>
              </div>
              <div className="col">
              <Link to="https://play.google.com/store/apps/details?id=os.pokledlite" target="_blank">
                  <ImageComponent src="/img/gplay.png" className="w-100" />
                </Link>
              </div>
            </div>

          </div>
        </div>
        <ImageComponent src="/img/line.png" className="w-100 line" />
      </div>
    </>
  );
}
